var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [!_vm.value ? [_c('state-request', _vm._g(_vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "outlined": "",
            "width": "100",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('span', [_vm._v(" 면접요청 ")])])];
      }
    }], null, false, 1266235541)
  }, 'state-request', {
    value: _vm.value,
    program: _vm.program,
    employee: _vm.employee,
    employer: _vm.employer,
    isUserEmployee: _vm.isUserEmployee,
    isUserEmployer: _vm.isUserEmployer
  }, false), {
    input: _vm.input
  }))] : [_c('v-layout', {
    staticStyle: {
      "gap": "8px"
    },
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('state-head', _vm._b({}, 'state-head', {
    value: _vm.value,
    isUserEmployee: _vm.isUserEmployee,
    isUserEmployer: _vm.isUserEmployer
  }, false)), _c('state-body', _vm._b({}, 'state-body', {
    value: _vm.value,
    isUserEmployee: _vm.isUserEmployee,
    isUserEmployer: _vm.isUserEmployer
  }, false))], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }